<template>
    <div class="msg-block" :class="type_msg">
        <p v-if="isText">{{text}}</p>
        <p v-if="isArray" v-for="(item_text, index) in text" :key="index">{{item_text}}</p>
    </div>
</template>

<script>
    export default {
        name: 'msg-block',
        data() { return{
            
        }},
        props: ['type_msg', 'text'],
        computed: {
            isText() {
                return !Array.isArray(this.text) 
            },
            isArray() {
                return Array.isArray(this.text) 
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/elements/msg.vue